import { type ButtonProps, Modal } from '@crm/ui';
import type * as React from 'react';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  /**
   * O que sera feito, em uma frase. Aceita conteudo montado quando alguma
   * parte precisa de destaque - perder dado nao pode passar em letra igual
   * ao resto.
   */
  message: React.ReactNode;
  confirmLabel?: string;
  /** Vermelho so quando a acao destroi algo; confirmar uma baixa nao destroi. */
  confirmVariant?: ButtonProps['variant'];
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * Confirmacao de acao. Usa a mesma modal do sistema, no lugar do
 * `window.confirm` do navegador.
 */
export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Excluir',
  confirmVariant = 'destructive',
  loading = false,
  onConfirm,
  onClose,
}: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      size="small"
      actions={[
        { label: 'Voltar', variant: 'ghost', onClick: onClose },
        { label: confirmLabel, variant: confirmVariant, loading, onClick: onConfirm },
      ]}
    >
      {typeof message === 'string' ? (
        <p className="text-sm text-muted-foreground">{message}</p>
      ) : (
        message
      )}
    </Modal>
  );
}
